// extracted by mini-css-extract-plugin
export default {"wrapper":"NoDesktop_wrapper__Szt2K"};